import React from 'react';
import EcoTitle from 'eco-design/base/eco-title';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import { Navigation } from 'swiper';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import useProductInfo from '@/utils/hooks/useProductInfo';
import getLocal from '@/app/utils/i18n';
import EcoLink from 'eco-design/base/eco-link';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import TC_Footer from '../Detail/componentsAU/TC_Footer';
import { saveAICookieForShopify, saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

interface Props {
    bundles: any[];
}

const Bundles: React.FC<Props> = ({ bundles }) => {
    const { gtm, useLang } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch');
    const { t: s } = useLang('shared.product.bundles');

    const { isH5 } = useDeviceDetect();

    const { locale } = getLocal();
    const list = useProductInfo(bundles, {}, true);

    const handleLinkClick = (bundle: any) => {
        saveAICookieForShopify(bundle?.link_buy, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            type: 'none',
            button_name: s('buy_now'),
            product_name: bundle.skuTitle || t(bundle?.title),
            position: 'Product Preview_Choose a Solution',
        });
    };

    return (
        <>
            <div className={css.comp}>
                <EcoTitle title={t('bundles.title')} />
                {isH5 ? (
                    <div className="bundles-swiper">
                        {list.map((i, idx) => (
                            <div className="bundle-item" key={idx}>
                                <EcoImg pc={i.variantImg} />
                                <div className="bundle-box">
                                    <div className="bundle-info">
                                        <div className="bundle-title">{i.skuTitle || t(i.title)}</div>
                                        <div className="bundle-power">{t(i.power)}</div>
                                        <div className="bundle-desc">{t(i.desc)}</div>
                                    </div>
                                    <div className="bundle-other">
                                        {i.price && (
                                            <div className="bundle-price">
                                                <div className="price">{FormatMoneyLocal(i.price, locale)}</div>
                                                {i.compareAtPrice && <div className="old-price">{FormatMoneyLocal(i.compareAtPrice, locale)}</div>}
                                            </div>
                                        )}
                                        <div className="bundle-installment">*Six interest-free installments</div>
                                        <EcoLink
                                            className="bundle-btn"
                                            href={`https://${locale}.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`}
                                            onClick={() => {
                                                handleLinkClick(i);
                                                saveCookieForShopify(`https://${locale}.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`, locale);
                                            }}
                                        >
                                            {s('buy_now')}
                                        </EcoLink>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <Swiper
                        className="bundles-swiper"
                        slidesPerView={'auto'}
                        navigation={{
                            nextEl: '.eco-swiper-button-next',
                            prevEl: '.eco-swiper-button-prev',
                        }}
                        modules={[Navigation]}
                    >
                        {list.map((i, idx) => (
                            <SwiperSlide className="bundle-item" key={idx}>
                                <EcoImg pc={i.variantImg} />
                                <div className="bundle-box">
                                    <div className="bundle-info">
                                        <div className="bundle-title">{i.skuTitle || t(i.title)}</div>
                                        <div className="bundle-power">{t(i.power)}</div>
                                        <div className="bundle-desc">{t(i.desc)}</div>
                                    </div>
                                    <div className="bundle-other">
                                        {i.price && (
                                            <div className="bundle-price">
                                                <div className="price">{FormatMoneyLocal(i.price, locale)}</div>
                                                {i.compareAtPrice && <div className="old-price">{FormatMoneyLocal(i.compareAtPrice, locale)}</div>}
                                            </div>
                                        )}
                                        <div className="bundle-installment">*Six interest-free installments</div>
                                        <EcoLink
                                            className="bundle-btn"
                                            href={`https://${locale}.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`}
                                            onClick={() => {
                                                handleLinkClick(i);
                                                saveCookieForShopify(`https://${locale}.ecoflow.com/cart/${i.variantId}:1?channel=buy_button`, locale);
                                            }}
                                        >
                                            {s('buy_now')}
                                        </EcoLink>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}

                <div className="bundle-footer">
                    <div className="eco-swiper-btn eco-swiper-button-prev">
                        <EcoIconArrow />
                    </div>
                    <div className="eco-swiper-btn eco-swiper-button-next">
                        <EcoIconArrow />
                    </div>
                </div>
            </div>
            <TC_Footer />
        </>
    );
};
export default Bundles;
